import React from "react";
import AdminNavPanel from "../pages/Admin/Components/AdminNavPanel";
import MainContent from "./components/MainContent";

const AdminLayout = (props) => {
  return (
    <>
      <div className="vds-viewport" id="viewport">
        <AdminNavPanel>
        </AdminNavPanel>
        <MainContent>
          {props.children}
        </MainContent>
      </div>
    </>
  );
};

export default AdminLayout;
